import { render, staticRenderFns } from "./DefaultCheckbox.vue?vue&type=template&id=1dffbfba"
import script from "./DefaultCheckbox.vue?vue&type=script&lang=js"
export * from "./DefaultCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DefaultCheckbox.vue?vue&type=style&index=0&id=1dffbfba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports